import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

const RichTextEditor = ({
  value,
  onChange,
  onSave,
  onCancel,
  placeholder = "Start typing...",
  height = "200px",
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link"],
      ["clean"],
    ],
  };

  return (
    <div className="rich-text-editor">
      <div className="editor-container" style={{ height }}>
        <ReactQuill
          value={value}
          onChange={onChange}
          modules={modules}
          placeholder={placeholder}
          className="question-content"
        />
      </div>
      <div className="editor-buttons">
        <button onClick={onSave} className="save-button">
          Save
        </button>
        <button onClick={onCancel} className="cancel-button">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default RichTextEditor;
